type ScrollOnActiveOptions = {
  behavior?: 'auto' | 'smooth';
  block?: 'start' | 'center' | 'end' | 'nearest';
  inline?: 'start' | 'center' | 'end' | 'nearest';
};

const defaultScrollOnActiveOptions: ScrollOnActiveOptions = {
  behavior: 'smooth',
  block: 'end',
  inline: 'center'
};

type ScrollOnActiveParams = [boolean, ScrollOnActiveOptions?];

export const scrollOnActive = (
  node: HTMLElement,
  [isActive = false, options = defaultScrollOnActiveOptions]
) => {
  let rafId: number;
  const update = ([active, options = defaultScrollOnActiveOptions]: ScrollOnActiveParams) => {
    if (active) rafId = requestAnimationFrame(() => node.scrollIntoView(options));
  };
  update([isActive, options]);

  return {
    update,
    destroy: () => cancelAnimationFrame(rafId)
  };
};
